<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <div class="md-layout">
          <h3 class="md-title">{{ $route.name }}</h3>
          <div
            class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
          >
            <md-field>
              <DropdownLink
                name="Clients"
                :array="permittedClients"
                @on-item-selected="setSelectedClient"
                @on-item-reset="resetClient"
              ></DropdownLink>
            </md-field>
          </div>
          <div
            class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
          >
            <md-field>
              <DropdownLink
                name="Contractors"
                :array="permittedContractorRegions"
                @on-item-selected="setSelectedContractor"
                @on-item-reset="resetContractor"
              ></DropdownLink>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item>
              <i class="material-icons">person</i>
              {{ name }} &nbsp; &nbsp;
              <md-button class="md-primary md-sm" v-on:click.native="logout"
                >Logout</md-button
              >
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { mapGetters } from "vuex";
import DropdownLink from "./components/DropdownList";
export default {
  components: {
    DropdownLink
  },
  data() {
    return {
      name: this.$auth.user.name || this.$auth.user.preferred_username
    };
  },
  mounted() {
    this.getClientList();
    this.getContractorList();
  },
  computed: {
    ...mapGetters({
      permittedClients: "portfolio/clients",
      permittedContractorRegions: "portfolio/contractorRegionDropdownOptions"
    })
  },
  methods: {
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    getClientList() {
      this.$store.dispatch("portfolio/getClientListing");
    },
    getContractorList() {
      this.$store.dispatch("portfolio/getContractorRegionDropdownOptions");
    },
    setSelectedClient(selectedClient) {
      this.$store.commit("set_global_client", selectedClient);
    },
    setSelectedContractor(selectedContractor) {
      this.$store.commit("set_global_contractor", selectedContractor);
    },
    resetClient() {
      this.$store.commit("set_global_client", {});
      this.getClientList();
    },
    resetContractor() {
      this.$store.commit("set_global_contractor", {});
      this.getContractorList();
    }
  }
};
</script>
